import { useState } from 'react'
import Swal from 'sweetalert2'
import { login } from '../../../Services/usuarioService'

function showAlert({ type, title, timer = 2000 }) {
  Swal.fire({
    position: 'top',
    toast: true,
    type,
    title,
    showConfirmButton: false,
    timer,
  })
}

export function useVerifyModal({ onSuccess, onClose }) {
  const [nameuser, setNameuser] = useState('')
  const [password, setPassword] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const res = await login(nameuser, password)
      const body = res.data
      let token = JSON.parse(atob(body.access_token.split('.')[1]))
      if (token.authorities.includes('ROLE_ADMIN')) {
        showAlert({
          type: 'success',
          title: 'Usuario administrador verificado',
          timer: 1500,
        })
        onSuccess()
        onClose()
      } else {
        showAlert({
          type: 'error',
          title: 'No tiene permisos de administrador',
        })
      }
    } catch {
      showAlert({
        type: 'info',
        title: 'Usuario o contraseña incorrecta',
      })
    }
  }

  return {
    nameuser,
    setNameuser,
    password,
    setPassword,
    handleSubmit,
  }
}